import React from 'react';

const BusinessAddress = ({ addressClass, hideName, hidePhone, hideEmail }) => (
	<address className={addressClass}>
		{!hideName && (
			<div className="mb-3">
				<strong> Ecofresh Cleaners</strong>
			</div>
		)}
		<strong>The Shoppe's at Matawan</strong><br />
		1008 Rt. 34, Matawan, NJ 07747<br />
		{!hidePhone && (
			<div>
				<abbr title="Phone"><i className="fa fa-phone" /></abbr>&emsp;(732) 583-5750
			</div>
		)}
		{!hideEmail && (
			<div>
				<abbr title="Email"><i className="fa fa-envelope" /></abbr>&emsp;chonghwalee@gmail.com
			</div>
		)}
	</address>
)

export default BusinessAddress;


// WEBPACK FOOTER //
// ./src/components/BusinessAddress.js